import { render } from "./CoursePopup.vue?vue&type=template&id=6bc2b905&scoped=true"
import script from "./CoursePopup.vue?vue&type=script&lang=js"
export * from "./CoursePopup.vue?vue&type=script&lang=js"

import "./CoursePopup.vue?vue&type=style&index=0&id=6bc2b905&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc2b905"]])

export default __exports__